// @ts-check

import { appModule } from '@/store/modules/app'
import { assignmentModule } from '@/store/modules/assignment'
import { authModule } from '@/store/modules/auth'
import { bankTransactionModule } from '@/store/modules/bankTransactions'
import { companyModule } from '@/store/modules/companyData'
import { customerModule } from '@/store/modules/customers'
import { dashboardModule } from '@/store/modules/dashboard'
import {
  accountTransactionModule,
  actionModule,
  entryModule,
  expenseModule,
  incomeModule
} from '@/store/modules/entries'
import { invoiceModule } from '@/store/modules/invoice'
import { mobileModule } from '@/store/modules/mobileData'
import { productModule } from '@/store/modules/products'
import { promotionCodeModule } from '@/store/modules/promotionCodes'
import { reportingDimensionModule } from '@/store/modules/reportingDimensions'
import { reportModule } from '@/store/modules/reports'
import { bankAccountModule } from '@/store/modules/settings/bankAccountSettings'
import { subscriptionModule } from '@/store/modules/settings/subscription'
import { swanAccountModule } from '@/store/modules/swanAccount'
import { assuranceModule } from '@/store/modules/ukkoturva'
import { utilModule } from '@/store/modules/utils'
import { vehicleModule } from '@/store/modules/vehicles'
import * as _ from 'lodash-es'
import { createStore } from 'vuex'

/** @type {import('vuex').Store<RootState>} */
export const store = createStore({
  strict: false,
  modules: {
    app: appModule,
    auth: authModule,
    utils: utilModule,
    expenses: expenseModule,
    incomes: incomeModule,
    actions: actionModule,
    allEntries: entryModule,
    assignment: assignmentModule,
    mobileData: mobileModule,
    companyData: companyModule,
    invoice: invoiceModule,
    dashboard: dashboardModule,
    customers: customerModule,
    products: productModule,
    reports: reportModule,
    bankTransactions: bankTransactionModule,
    bankAccounts: bankAccountModule,
    swanAccount: swanAccountModule,
    subscription: subscriptionModule,
    vehicles: vehicleModule,
    reportingDimensions: reportingDimensionModule,
    promotionCodes: promotionCodeModule,
    'account-transactions': accountTransactionModule,
    ukkoturva: assuranceModule
  },
  plugins: [
    (pluginStore) => {
      window.addEventListener(
        'resize',
        _.debounce(() => {
          pluginStore.commit('app/setDimensions', {
            width: window.innerWidth,
            height: window.innerHeight
          })
        }, 200),
        false
      )
    }
  ]
})

export default store
